var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

import * as React from 'react';
import { classNames } from '@progress/kendo-react-common';
import { getItemValue } from './utils';

var preventDefault = function preventDefault(e) {
  return e.preventDefault();
};
/**
 * @hidden
 */


var ListDefaultItem = function (_super) {
  __extends(ListDefaultItem, _super);

  function ListDefaultItem() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  ListDefaultItem.prototype.render = function () {
    var _a = this.props,
        selected = _a.selected,
        defaultItem = _a.defaultItem,
        textField = _a.textField;
    return React.createElement("div", {
      onClick: this.props.onClick,
      onMouseDown: preventDefault,
      className: classNames('k-list-optionlabel', {
        'k-state-selected': selected
      })
    }, getItemValue(defaultItem, textField) || '');
  };

  return ListDefaultItem;
}(React.Component);

export default ListDefaultItem;